<template>
  <transition
    enter-active-class="animated fadeIn"
    leave-to-class="animated fadeOut"
  >
    <div class="pt-1 pl-2 pr-2 text-xs text-danger" v-if="errorsForm.has(attributeName)">
      <span class="error-message">{{ errorsForm.first(attributeName) }}</span>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'FormError',
  props: ['attributeName', 'errorsForm']
};
</script>
